// extracted by css-extract-rspack-plugin
export default {"modelName":"ModelSwitcher-module__modelName__NHhNpTy","selectAnchor":"ModelSwitcher-module__selectAnchor__LSDCXYT"};